'use client';

import type { ImageGalleryFragment } from '@packages/gql/generated/shopping/graphql';
import { ErrorBoundary } from '@packages/shared/src/ui/ErrorBoundary/ErrorBoundary';
import { ZoomDialog } from '../../ZoomDialog/ZoomDialog.client';
import { ErrorFallback } from '../../ZoomDialog/ErrorFallback/ErrorFallback.client';
import {
  useActiveSlide,
  useIsDialogOpen,
} from '../ImageGalleryProvider/ImageGalleryProvider.client';

type ImageGalleryZoomDialogWrapperProps = {
  product: ImageGalleryFragment;
};

export const ImageGalleryZoomDialogWrapper = ({ product }: ImageGalleryZoomDialogWrapperProps) => {
  const [zoomDialogOpen, setZoomDialogOpen] = useIsDialogOpen();
  const [selectedIndex] = useActiveSlide();
  return (
    <>
      {zoomDialogOpen && (
        <ErrorBoundary
          fallback={(reset) => (
            <ErrorFallback
              onClose={() => {
                setZoomDialogOpen(false);
                reset();
              }}
            />
          )}
        >
          <ZoomDialog
            data={product}
            carouselIndex={selectedIndex}
            open={zoomDialogOpen}
            close={() => setZoomDialogOpen(false)}
          />
        </ErrorBoundary>
      )}
    </>
  );
};
